import type { ReactNode } from 'react';

type EmptyStateProps = {
  title?: string;
  subtitle?: string;
  description?: string;
  action?: ReactNode;
  icon?: ReactNode;
};

const EmptyState = ({
  title = 'Nothing here yet',
  subtitle,
  description,
  action = null,
  icon = null,
}: EmptyStateProps) => {
  const body = subtitle ?? description ?? 'Check back later for updates.';
  return (
    <div
      className="flex w-full flex-col items-center justify-center px-8 py-24 text-center"
      style={{ animation: 'ac-fade-in 0.6s ease-out' }}
    >
      <div
        className="relative mb-12 flex items-center justify-center"
        style={{ animation: 'ac-float 4s ease-in-out infinite' }}
      >
        {icon || (
          <div className="relative flex h-40 w-40 flex-col rounded-[24px] border border-[var(--border-subtle)] bg-[var(--bg-secondary)] p-6 shadow-[0_20px_40px_rgba(0,0,0,0.1)]">
            <div className="grid h-full grid-cols-3 gap-3">
              <div className="col-span-3 mb-1 h-3 rounded-md bg-[var(--bg-primary)] opacity-50" />
              <div className="rounded-md bg-[var(--bg-primary)] opacity-30" />
              <div className="rounded-md bg-[var(--bg-primary)] opacity-30" />
              <div className="rounded-md bg-[var(--accent-primary)] opacity-20" />
              <div className="rounded-md bg-[var(--bg-primary)] opacity-30" />
              <div className="rounded-md bg-[var(--bg-primary)] opacity-30" />
              <div className="rounded-md bg-[var(--accent-primary)] opacity-20" />
              <div className="rounded-md bg-[var(--bg-primary)] opacity-30" />
              <div className="rounded-md bg-[var(--bg-primary)] opacity-30" />
              <div className="rounded-md bg-[var(--accent-primary)] opacity-20" />
            </div>
            <div className="absolute -right-2.5 -top-2.5 z-[2] flex h-[70px] w-[70px] items-center justify-center rounded-[20px] border border-[var(--border-subtle)] bg-[var(--bg-secondary)] text-[2.5rem] font-extrabold text-[var(--text-muted)] shadow-[0_10px_20px_rgba(0,0,0,0.1)]">
              0
            </div>
          </div>
        )}
      </div>
      <h3 className="mb-3 text-2xl font-bold tracking-[-0.01em] text-[var(--text-secondary)] opacity-80">{title}</h3>
      <p className="max-w-[400px] text-base leading-6 text-[var(--text-muted)]">{body}</p>
      {action}
    </div>
  );
};

export default EmptyState;
